import Layout from '@/layout'

import myCourse from './modules/myCourse'
import userCenter from './modules/userCenter'
// import activity from './modules/activity'
// import notice from './modules/notice'
// import thesis from './modules/thesis'
// import myevents from './modules/myevents'

const routes = [
  {
    path: '/',
    title: '首页',
    component: Layout,
    key: 'home',
    redirect: '/dashboard',
    name: 'Home',
    children: [
      {
        path: 'dashboard',
        name: 'HomeDashboard',
        component: () => import('@/views/HomePage/index.vue'),
        meta: { title: '', icon: 'dashboard', isShowSidebar: false }
      },
      {
        path: 'answer-zone',
        name: 'AnswerZone',
        component: () => import('@/views/AnswerZone/index.vue'),
        meta: { title: '答疑专区', icon: 'dashboard', isShowSidebar: false }
      }
    ]
  },

  // myevents,
  // activity,
  // notice,
  // thesis,
  // {
  //   path: '/docs',
  //   title: '常用文档',
  //   component: Layout,
  //   redirect: '',
  //   children: [
  //     {
  //       path: '',
  //       name: 'DocsIndex',
  //       component: () => import('@/views/CommonDocs/index.vue'),
  //       meta: { title: '常用文档', isShowSidebar: false }
  //     }
  //   ]
  // },

  {
    path: '/calendar',
    title: '直播日历',
    component: Layout,
    key: 'calendar',
    redirect: '/calendar/dashboard',
    name: 'Calendar',
    children: [
      {
        path: 'dashboard',
        name: 'CalendarDashboard',
        component: () => import('@/views/HomeView.vue'),
        meta: { title: '', icon: 'dashboard', isShowSidebar: false }
      }
    ]
  },
  myCourse,
  userCenter
  // {
  //   path: '/force-assessment:id',
  //   title: '强制课程评估',
  //   component: Layout,
  //   hidden: true,
  //   children: [
  //     {
  //       path: '',
  //       name: 'forceAssessment',
  //       component: () => import('@/views/MyCourse/Assessment/detail.vue'),
  //       meta: { title: '强制课程评估', icon: 'dashboard', isShowSidebar: false }
  //     }
  //   ]
  // }
]

export default routes
